import { Button } from 'evergreen-ui'
import styled from 'styled-components'

export const XSmallButton = styled(Button).attrs({ size: 'small', height: 30, fontSize: '15px' })``
